import apiClient from "./index";

export const productsApi = {
	// 제품 목록 조회
	getProducts: async (category) =>{
		return await apiClient.get(`/products/${category}`, {
			skipAuth: true
		});
	} ,
	// 상세 페이지 조회
	getProductDetail: async (productCode) => {
		return await apiClient.get(`/products/detail/${productCode}`, {
			skipAuth: true
		});
	}
}